import { connect } from "react-redux";
import { Dispatch } from "redux";
import IAppState from "../../redux/types/IAppState";
import MyCasesPage from "./MyCasesPage";
import { getUserCRMValuesThunk } from "../../redux/thunks/AccountThunks";

export default connect(
    (state: IAppState) => ({
        powerPortalURL: state.membersPortal.powerPortalURL,
        currentUserGuid: state.account.currentUserGuid,
        currentUserNameNumber: state.account.currentUserNameNumber,
        viewAsAccessRequests: state.membersPortal.viewAsAccessRequests,
    }),
    (dispatch: Dispatch) => ({
        getUserCRMValues: () => dispatch<any>(getUserCRMValuesThunk()),
    })
)(MyCasesPage);